/**
 * 第三方插件加载
 */
angular.module("thirdPartyPluginsModule", [])
    .factory("thirdPartyPlugins", ["$q", function($q) {
        return {
            /**
             * [get135plugins description] 获取135编辑器插件
             * @param {boolean} [allow] [description] 是否允许使用
             * @return {[type]} [description]
             */
            get135plugins: function(allow) {
                var deffer = $q.defer();
                if (allow === false) {
                    deffer.resolve();
                } else {
                    LazyLoad.js(["./lib/ueditor2/dialogs/135editor/135editor.js"], function() {
                        deffer.resolve();
                    });
                }
                return deffer.promise;
            },
            /**
             * [getXiumiPlugins description] 获取秀米插件
             * @param {boolean} [allow] [description] 是否允许使用
             * @return {[type]} [description]
             */
            getXiumiPlugins: function(allow) {
                var deffer = $q.defer();
                if (allow === false) {
                    deffer.resolve();
                } else {
                    LazyLoad.js(["./lib/ueditor2/dialogs/xiumi/xiumi-ue-dialog-v5.js"], function() {
                        deffer.resolve();
                    });
                }
                return deffer.promise;
            }
        }
    }]);